import moment from 'moment'

export function formatDateTime (inputDateTime) {
  return (
    '\u200E' + moment(inputDateTime).locale('en').format('DD MMM YYYY hh:mm A')
  )
}
export function formatDateTimeAr (inputDateTime) {
  return (
    '\u200E' + moment(inputDateTime).locale('ar').format('DD MMM YYYY hh:mm A')
  )
}

export function formatDate (inputDate) {
  const date = moment(inputDate, [
    'YYYY-MM-DD',
    'DD/MM/YYYY',
    'DD-MM-YYYY',
    'MM-DD-YYYY',
    'MM-DD-YY',
    'DD-MM-YY'
  ])
  return '\u200E' + moment(date).format('DD MMM YYYY')
}

// Use this when the value is a full ISO datetime string (e.g. "2026-02-01T19:00:00.000Z")
// It correctly applies the local timezone offset before showing date-only output.
export function formatDateFromISO (inputDate) {
  return '\u200E' + moment(inputDate).format('DD MMM YYYY')
}
export function formatDateYear (inputDate) {
  const date = moment(inputDate, [
    'YYYY-MM-DD',
    'DD/MM/YYYY',
    'DD-MM-YYYY',
    'MM-DD-YYYY',
    'MM-DD-YY',
    'DD-MM-YY'
  ])
  return moment(date).format('YYYY-MM-DD')
}
export const isValidDate = value => {
  if (!value) return false
  const d = new Date(value)
  return d instanceof Date && !isNaN(d.getTime())
}

export function formatTime (inputTime) {
  return moment(inputTime).format('h:mm A')
}
export const formatInputTime = isoString => {
  if (!isoString) return null
  return new Date(isoString)
}

export const formatSendTime = dateString => {
  if (!dateString) return '0000-01-01T00:00:00Z'

  let date = new Date(dateString)
  let timePart = date.toISOString().substring(11, 19)
  return `0000-01-01T${timePart}Z`
}

// Input 14/02/2025 12:36 pm
export const formatConvertedDateTime = inputDateTime => {
  return (
    '\u200E' +
    moment(inputDateTime, 'DD-MM-YYYY hh:mm a').format('DD MMM YYYY hh:mm A')
  )
}

export const getDateMinusThreeMonths = () => {
  return moment().subtract(3, 'months').toDate()
}

export const convertTimeToDate = (timeStr, baseDate = new Date()) => {
  const base = moment(baseDate)
  const time = moment(timeStr, 'HH:mm')

  return base
    .set({
      hour: time.hour(),
      minute: time.minute(),
      second: 0,
      millisecond: 0
    })
    .toDate()
}
